import styled from "styled-components";

export const CardArea = styled.div`
  display: flex;
  padding: 24px 16px;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
  gap: 16px;
  border-radius: 10px;
  background: #c8cfea;

  margin-bottom: 16px;
`;

export const CardStatusArea = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  align-self: stretch;
`;

export const StatusArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const StatusDiv = styled.div`
  width: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const StatusDivFree = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const StatusIcon = styled.div`
  background-image: url(${(props) => props.image});
  background-color: #fff;
  background-size: 32px;

  position: relative;
  display: inline-block;
  vertical-align: top;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-position: center;
  background-repeat: no-repeat;
`;

export const StatusText = styled.div`
  display: flex;
  padding: 8px 12px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 10px;

  background-color: ${(props) => props.active && "#fff"};

  color: #9798bb;
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px; /* 100% */

  margin-top: ${(props) => (props.active ? "0px" : "8px")};
`;

export const StatusTextAfter = styled.div`
  content: "";
  border-width: 0 8px 10px 8px;
  border-style: solid;
  border-color: transparent transparent #fff transparent;
`;

export const NextStatus = styled.div`
  display: flex;
  height: 40px;
  align-items: center;
  gap: 10px;
`;

export const SeparateLine = styled.div`
  height: 1px;
  align-self: stretch;
  background: #b0b4d2;
`;

export const HsptTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;

  color: #464473;
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 142.857% */
`;

export const PayResult = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
`;

export const PayPrice = styled.div`
  color: #464473;
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 142.857% */
`;

export const PayCardInfo = styled.div`
  display: flex;
  padding: 5px 8px;
  justify-content: center;
  align-items: center;
  gap: 10px;

  color: #fff;
  font-family: Pretendard;
  font-size: 10px;
  font-style: normal;
  font-weight: 600;
  line-height: 10px; /* 100% */

  border-radius: 10px;
  background: #6a62e6;
`;

export const BottomBtn = styled.div`
  display: flex;
  padding: 12px 40px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-radius: 10px;
  background: #fff;
`;

export const BottomShortBtn = styled.div`
  display: flex;
  padding: 12px 24px;
  align-items: center;
  gap: 10px;
  border-radius: 10px;
  background: #fff;
  /* float: left; */
  float: ${(props) => (props.float ? props.float : "left")};
`;

export const InputArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
`;

// 접수 약국 변경 START
export const TextInputDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

export const InputTypeText = styled.input`
  display: flex;
  padding: 10.5px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;

  border-radius: 6px !important;
  border: 1px solid #d0d0d0;
  background: #fff;
  height: 27px;
`;
// 접수 약국 변경 END

export const TitleTd = styled.td`
  color: #888;
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px; /* 150% */
  padding-right: 24px;
  width: 10vw;
  vertical-align: top;
`;

export const ContentTd = styled.td`
  color: #333;
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px; /* 150% */
  display: flex;
`;

export const TableDiv = styled.div`
  display: flex;
  gap: 24px;
`;

export const TableTitleDiv = styled.div`
  color: #888;
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px; /* 150% */
  /* padding-right: 24px; */
  /* width: 10vw; */
  vertical-align: top;
`;

export const TableContentDiv = styled.div`
  color: #333;
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px; /* 150% */
  display: flex;
`;
